import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";
import InterfaceProperties from "../../../components/Interface/InterfaceProperties";
import InterfaceCompatibility from "../../../components/Interface/InterfaceCompatibility";

class Component_report_html extends PureComponent {
  render() {
    return (
      <div className="row" id="component_report_html">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Report HTML</h2>
              <p>
                HTML reports allow you to write custom JavaScript eval to query
                the Nexoid API or Nexoid interface libraries (NL) and generate
                HTML to display inside the Nexoid application. To use JavaScript
                code in JSON you will need to run it through the{" "}
                <PageLink
                  to="Integration/node_js_2_json"
                  text="Node.js 2 JSON Tool"
                />{" "}
                The HTML report component includes a “download to CSV” function
                which takes HTML tables and separates them out as one cell per
                (,) and one row per new line.
              </p>
              <p>
                The “html_eval” callback function expects a string of valid
                HTML.
              </p>

              <InterfaceCompatibility
                dashboard={true}
                record={true}
                report={true}
                search={true}
              />
              <InterfaceProperties
                type={"report_html"}
                name={"report html"}
                padding={true}
                hide={true}
                order={true}
                properties={[
                  {
                    property: "html_eval",
                    description:
                      "Generates the HTML inside the HTML table component. ",
                    defaults: '""',
                  },
                  {
                    property: "refresh",
                    description:
                      "Graph data refresh loop delay in seconds.",
                    defaults: '60 - 86400 default is 300 (5 minutes)',
                  },
                ]}
              />

              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Report HTML Example</h2>
            </section>
            <section>
              <h3>Example 1: HTML Report</h3>
              <p>
                This report displays a list of users and usernames. The ID part
                of the report is clickable and will navigate you to the system
                settings for each user. There is a download csv link which will
                download the report to a csv file. The html_eval component is
                JavaScript that has been run through the Node.js 2 JSON tool
                found on this website. Below is the raw JavaScript.
              </p>
              <p>
                *Note you will need administrator or "system - user - read"
                permission to run this example as it reads the user table.
              </p>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1 jsonY">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"report_html"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"html_eval"</span>:{" "}
                  <span className="jsonY">
                    "
                    {
                      'var options = {\\nsystem_record: true,\\noutput: [\\n\\"text_first_name\\",\\n\\"text_last_name\\",\\n\\"text_username\\",\\n\\"text_api_name\\",\\n],\\n};\\nNL.Record.search(\\"user\\", options, function (err, data) {\\nif (err) {\\nhtml = \\"<div>Report search failed.</div>\\";\\ncallback(null, html);\\n} else {\\nif (data.records.length === 0) {\\nhtml = \\"<div>No results returned</div>\\";\\ncallback(null, html);\\n} else {\\nvar d = data.records;\\nfor (var i = 0; i < d.length; i++) {\\nd[i] = {\\nid: d[i].id,\\nusername: d[i].record.text_username,\\nname:\\ntypeof d[i].record.text_api_name === \\"string\\"\\n? d[i].record.text_api_name\\n: d[i].record.text_first_name + \\" \\" + d[i].record.text_last_name,\\n};\\n}\\nvar html = generateTables(d);\\ncallback(null, html);\\n}\\n}\\n});\\nfunction generateTables(records) {\\nNL.Page[event.id] = event.control;\\nvar html = \\"\\";\\nhtml += \'<div style=\\"text-align: right\\">\';\\nhtml +=\\n\'<span class=\\"navLink\\" onclick=\\"NL.Page.\' +\\nevent.id +\\n\\".downloadCSV(\'users\')\\\\\\">download</span>\\";\\nhtml += \\"</div>\\";\\nhtml += \'<table class=\\"reportTable\\">\';\\nhtml += \\"<tr>\\";\\nhtml += \\"<th>\\";\\nhtml += \\"USER ID\\";\\nhtml += \\"</th>\\";\\nhtml += \\"<th>\\";\\nhtml += \\"Username\\";\\nhtml += \\"</th>\\";\\nhtml += \\"<th>\\";\\nhtml += \\"Name\\";\\nhtml += \\"</th>\\";\\nhtml += \\"</tr>\\";\\nfor (var r = 0; r < records.length; r++) {\\nhtml += \\"<tr>\\";\\nhtml += \\"<td>\\";\\nhtml +=\\n\'<span class=\\"navLink\\" onClick=\\"NL.Interface.navigateTo(\\\\\'/settings/user/USER-\' +\\nrecords[r].id +\\n\\"\'); \\\\\\">\\";\\nhtml += \\"USER-\\" + records[r].id;\\nhtml += \\"</span>\\";\\nhtml += \\"</td>\\";\\nhtml += \\"<td>\\";\\nhtml += records[r].username;\\nhtml += \\"</td>\\";\\nhtml += \\"<td>\\";\\nhtml += records[r].name;\\nhtml += \\"</td>\\";\\nhtml += \\"</tr>\\";\\n}\\nhtml += \\"</table>\\";\\nreturn html;\\n}'
                    }
                    "
                  </span>
                </div>
                <div>&#125;</div>
              </div>
              <p>Example 1: Raw html_eval JavaScript</p>
              <div className="darkCode">
                <div className="">{"var options = {"}</div>
                <div className="i1 ">{"  system_record: true,"}</div>
                <div className="i1 ">{"  output: ["}</div>
                <div className="i2 ">{'    "text_first_name",'}</div>
                <div className="i2 ">{'    "text_last_name",'}</div>
                <div className="i2 ">{'    "text_username",'}</div>
                <div className="i2 ">{'    "text_api_name",'}</div>
                <div className="i1 ">{"  ],"}</div>
                <div className="">{"};"}</div>
                <div className="">{""}</div>
                <div className="">
                  {'NL.Record.search("user", options, function (err, data) {'}
                </div>
                <div className="i1 ">{"  if (err) {"}</div>
                <div className="i2 ">
                  {'    html = "<div>Report search failed.</div>";'}
                </div>
                <div className="i2 ">{"    callback(null, html);"}</div>
                <div className="i1 ">{"  } else {"}</div>
                <div className="i2 ">
                  {"    if (data.records.length === 0) {"}
                </div>
                <div className="i3 ">
                  {'      html = "<div>No results returned</div>";'}
                </div>
                <div className="i3 ">{"      callback(null, html);"}</div>
                <div className="i2 ">{"    } else {"}</div>
                <div className="i3 ">{"      var d = data.records;"}</div>
                <div className="i3 ">{""}</div>
                <div className="i3 ">
                  {"      for (var i = 0; i < d.length; i++) {"}
                </div>
                <div className="i4 ">{"        d[i] = {"}</div>
                <div className="i5 ">{"          id: d[i].id,"}</div>
                <div className="i5 ">
                  {"          username: d[i].record.text_username,"}
                </div>
                <div className="i5 ">{"          name:"}</div>
                <div className="i5 ">
                  {'            typeof d[i].record.text_api_name === "string"'}
                </div>
                <div className="i5 ">
                  {"              ? d[i].record.text_api_name"}
                </div>
                <div className="i5 ">
                  {
                    '              : d[i].record.text_first_name + " " + d[i].record.text_last_name,'
                  }
                </div>
                <div className="i4 ">{"        };"}</div>
                <div className="i3 ">{"      }"}</div>
                <div className="i3 ">{""}</div>
                <div className="i3 ">
                  {"      var html = generateTables(d);"}
                </div>
                <div className="i3 ">{""}</div>
                <div className="i3 ">{"      callback(null, html);"}</div>
                <div className="i2 ">{"    }"}</div>
                <div className="i1 ">{"  }"}</div>
                <div className="">{"});"}</div>
                <div className="">{""}</div>
                <div className="">{"function generateTables(records) {"}</div>
                <div className="i1 ">
                  {"  NL.Page[event.id] = event.control;"}
                </div>
                <div className="i1 ">{'  var html = "";'}</div>
                <div className="i1 ">
                  {"  html += '<div style=\"text-align: right\">';"}
                </div>
                <div className="i1 ">{"  html +="}</div>
                <div className="i1 ">
                  {'    \'<span class="navLink" onclick="NL.Page.\' +'}
                </div>
                <div className="i1 ">{"    event.id +"}</div>
                <div className="i1 ">
                  {'    ".downloadCSV(\'users\')\\">download</span>";'}
                </div>
                <div className="i1 ">{'  html += "</div>";'}</div>
                <div className="i1 ">
                  {"  html += '<table class=\"reportTable\">';"}
                </div>
                <div className="i1 ">{'  html += "<tr>";'}</div>
                <div className="i1 ">{'  html += "<th>";'}</div>
                <div className="i1 ">{'  html += "USER ID";'}</div>
                <div className="i1 ">{'  html += "</th>";'}</div>
                <div className="i1 ">{'  html += "<th>";'}</div>
                <div className="i1 ">{'  html += "Username";'}</div>
                <div className="i1 ">{'  html += "</th>";'}</div>
                <div className="i1 ">{'  html += "<th>";'}</div>
                <div className="i1 ">{'  html += "Name";'}</div>
                <div className="i1 ">{'  html += "</th>";'}</div>
                <div className="i1 ">{'  html += "</tr>";'}</div>
                <div className="i1 ">
                  {"  for (var r = 0; r < records.length; r++) {"}
                </div>
                <div className="i2 ">{'    html += "<tr>";'}</div>
                <div className="i2 ">{'    html += "<td>";'}</div>
                <div className="i2 ">{"    html +="}</div>
                <div className="i2 ">
                  {
                    "      '<span class=\"navLink\" onClick=\"NL.Interface.navigateTo(\\'/settings/user/USER-' +"
                  }
                </div>
                <div className="i2 ">{"      records[r].id +"}</div>
                <div className="i2 ">{'      "\'); \\">";'}</div>
                <div className="i2 ">
                  {'    html += "USER-" + records[r].id;'}
                </div>
                <div className="i2 ">{'    html += "</span>";'}</div>
                <div className="i2 ">{'    html += "</td>";'}</div>
                <div className="i2 ">{'    html += "<td>";'}</div>
                <div className="i2 ">{"    html += records[r].username;"}</div>
                <div className="i2 ">{'    html += "</td>";'}</div>
                <div className="i2 ">{'    html += "<td>";'}</div>
                <div className="i2 ">{"    html += records[r].name;"}</div>
                <div className="i2 ">{'    html += "</td>";'}</div>
                <div className="i2 ">{'    html += "</tr>";'}</div>
                <div className="i1 ">{"  }"}</div>
                <div className="i1 ">{'  html += "</table>";'}</div>
                <div className="i1 ">{""}</div>
                <div className="i1 ">{"  return html;"}</div>
                <div className="">{"}"}</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_report_html;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_report_html.js